import {DeviceModel} from "./device-model";
import {Device} from "./device";
import {Http} from "@angular/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {contextPath} from "site";

const apiURL = `${contextPath}/api/`;
const deviceModelsApiURL = `${apiURL}device-models/`;

@Injectable()
export class DeviceCommonService {
	protected deviceModels = this.http.get(`${deviceModelsApiURL}`)
		.map(response => (response.json() as Array<any>).map(json => DeviceModel.fromJSON(json)))
		.publishLast()
		.refCount();

	constructor(
		protected http: Http) {
	}

	protected linkDeviceModels(devices: Observable<Array<Device>>): Observable<Array<Device>> {
		return Observable.combineLatest(
			devices,
			this.deviceModels,
			(devices, deviceModels) => {
				for (let device of devices) {
					device.model = deviceModels.find(m => m.id === device.modelID);
				}
				return devices;
			});
	}

	getDeviceModels(): Observable<Array<DeviceModel>> {
		return this.deviceModels;
	}
}
